import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

/**
 * Hook to get the current organization ID from URL params or Redux store
 * This replaces the complex custom parameter parsing hooks
 */
export const useOrgId = (): number | null => {
    const { orgId } = useParams<{ orgId: string }>();
    const selectedParentOrgId = useSelector((state: RootState) => state.OrganizationListStore?.selectedParentOrgId);
    
    // Priority: URL param first, then selected org from store
    if (orgId) {
        return parseInt(orgId, 10);
    }
    
    return selectedParentOrgId || null;
};

export default useOrgId;